/**
 * Copyright 2022 (C) Blink - All Rights Reserved
 *
 * This source code is protected under international copyright law.  All rights
 * reserved and protected by the copyright holders.
 * All files are confidential and only available to authorized individuals with the
 * permission of the copyright holders. If you encounter any file and do not have
 * permission, please get in touch with the copyright holders and delete this file.
 */
import getChoiceIconStyle from "assets/getChoiceIconStyle";

const Egg = ({ isActive = false }) => {
  const fill = getChoiceIconStyle(isActive);

  return (
    <svg
      width="48"
      height="47"
      viewBox="0 0 48 47"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M12.8148 10.441C9.8388 15.063 7.86241 21.1165 7.86241 26.7973C7.86241 32.9492 9.8153 37.4941 12.6795 40.4943C15.5489 43.4999 19.3866 45.0136 23.2713 45.0136C27.156 45.0136 30.9936 43.4999 33.863 40.4943C36.7273 37.4941 38.6801 32.9492 38.6801 26.7973C38.6801 21.1165 36.7038 15.063 33.7278 10.441C30.7179 5.76639 26.877 2.82848 23.2713 2.82848C19.6656 2.82848 15.8246 5.76639 12.8148 10.441ZM11.2117 9.40885C14.3317 4.56327 18.6718 0.921875 23.2713 0.921875C27.8708 0.921875 32.2109 4.56327 35.3308 9.40885C38.4846 14.3071 40.5867 20.7146 40.5867 26.7973C40.5867 33.3666 38.4922 38.4065 35.2421 41.8108C31.9972 45.2097 27.6538 46.9202 23.2713 46.9202C18.8888 46.9202 14.5453 45.2097 11.3005 41.8108C8.0504 38.4065 5.95581 33.3666 5.95581 26.7973C5.95581 20.7146 8.05791 14.3071 11.2117 9.40885Z" />
      <path d="M23.271 21.9466C18.4706 21.9466 14.5792 25.8381 14.5792 30.6384C14.5792 35.4387 18.4706 39.3302 23.271 39.3302C28.0713 39.3302 31.9627 35.4387 31.9627 30.6384C31.9627 25.8381 28.0713 21.9466 23.271 21.9466ZM12.6726 30.6384C12.6726 24.7851 17.4177 20.04 23.271 20.04C29.1243 20.04 33.8693 24.7851 33.8693 30.6384C33.8693 36.4917 29.1243 41.2368 23.271 41.2368C17.4177 41.2368 12.6726 36.4917 12.6726 30.6384Z" />
      <path d="M29.024 29.6846C29.5505 29.6858 29.9762 30.1137 29.975 30.6402C29.9707 32.4159 29.2629 34.1175 28.0065 35.3724C26.7502 36.6272 25.0477 37.333 23.2719 37.3352C22.7455 37.3358 22.3181 36.9095 22.3175 36.383C22.3169 35.8565 22.7432 35.4292 23.2697 35.4286C24.5409 35.427 25.7597 34.9218 26.6592 34.0234C27.5586 33.125 28.0653 31.9068 28.0684 30.6356C28.0696 30.1091 28.4975 29.6833 29.024 29.6846Z" />
    </svg>
  );
};

export default Egg;
